import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { UserContex } from "../context API/UserContext";

const ChangePassword = () => {
  const [userData, setUserData] = useContext(UserContex);
  const [email, setEmail] = useState(userData.user?.email);
  const navigate = useNavigate();
    console.log(email);
  const [newPassword, setNewPassword] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  // console.log(userData?.user);
  useEffect(() => {
    if (!userData.user) {
      navigate("/");
    }
  }, [userData.user, navigate]);
  const handlesubmit = (e) => {
    e.preventDefault();
    axios
      .put("https://back.waratechnology.com/api/user/update", {
       email,
        newPassword,
        oldPassword,
      })
      .then((res) => {
        console.log(res);
        alert(res.data.msg);
        navigate("/");
      })
      .catch((err) => alert(err.response.data.msg));
  };
  return (
    <div className="">
      <div className="bg-gray-400  flex justify-center items-center h-screen pt-12 ">
        <div className="w-3/4 h-3/4 md:w-1/2 md:h-3/4 bg-white  border border-black-1 border-rounded rounded-2xl p-4 shadow-lg shadow-white-500/50 ">
          <div className="flex justify-center mt-2 mb-4">
            <h1 className="uppercase font-bold text-2xl">Change Password</h1>
          </div>
          <form onSubmit={handlesubmit}>
            <label className="mt-4 font-bold">Old Password</label>
            <input
              placeholder="Old Password"
              type="text"
              className="w-full  pl-2 h-12 md:h-8 mb-4 border border-gray-300 rounded-2xl"
              onChange={(e) => setOldPassword(e.target.value)}
            />

            <label className="mt-4 font-bold">New Password</label>
            <input
              placeholder="New Password"
              type="password"
              className="w-full h-12 md:h-8 pl-2 border border-gray-300 rounded-2xl"
              onChange={(e) => setNewPassword(e.target.value)}
            />

            <div className="flex justify-center mt-4">
              <button
                type=""
                className="uppercase bg-red-500 mt-4 text-white px-4 py-1 rounded rounded-fully"
              >
                Change
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
// const nodemailer = require("nodemailer");

// const transporter = nodemailer.createTransport({
//   host: "smtp.ethereal.email",
//   port: 587,
//   secure: false, // true for port 465, false for other ports
//   auth: {
//     user: "maddison53@ethereal.email",
//     pass: "jn7jnAPss4f63QBp6D",
//   },
// });

// // async..await is not allowed in global scope, must use a wrapper
// async function main() {
//   // send mail with defined transport object
//   const info = await transporter.sendMail({
//     from: '"Maddison Foo Koch 👻" <maddison53@ethereal.email>', // sender address
//     to: "bar@example.com, baz@example.com", // list of receivers
//     subject: "Hello ✔", // Subject line
//     text: "Hello world?", // plain text body
//     html: "<b>Hello world?</b>", // html body
//   });

//   console.log("Message sent: %s", info.messageId);
//   // Message sent: <d786aa62-4e0a-070a-47ed-0b0666549519@ethereal.email>
// }
// main().catch(console.error);//
export default ChangePassword;
